import { Block, BlockSchema } from './Block.types';

import { MagicResourceBlockConfigSchema, BlockType } from './blockConfig/Types';

import { z } from 'zod';

export const MagicResourceLibraryBlockSchema = BlockSchema.extend({
  blockConfig: MagicResourceBlockConfigSchema,
});

export type MagicResourceLibraryBlock = z.infer<typeof MagicResourceLibraryBlockSchema>;

export function isMagicResourceLibraryBlock(block: Block): block is MagicResourceLibraryBlock {
  return block.blockConfig.type === BlockType.MagicResourceLibrary;
}
